import { Link } from "react-router-dom";
import Layout from "../Layout";
import SEOHead from "../SEOHead";
import ServiceSchema from "../ServiceSchema";
import HeroSection from "./HeroSection";          // Same folder
import heroImage from "../assets/pre- engineered metal building(PEMB)1.png"; // Adjust path if needed

const ShedFabrication = () => {
  const shedTypes = [
    "Factory Sheds",
    "Warehouse Sheds",
    "Storage Sheds",
    "Poultry Sheds",
    "Fabrication Yard Sheds",
    "Agricultural & Farm Sheds",
    "Temporary/Portable Structures",
  ];

  const features = [
    {
      title: "Customized Shed Designs",
      description: "Built according to your space, purpose, height, and workflow.",
    },
    {
      title: "Premium Build Quality",
      description: "We use heavy-duty steel for long-lasting performance.",
    },
    {
      title: "Efficient Installation",
      description: "Fast, clean, and professional on-site erection.",
    },
    {
      title: "Affordable Pricing",
      description: "Cost-effective solutions without compromising durability.",
    },
    {
      title: "Complete Turnkey Assistance",
      description: "Design + Fabrication + Supply + Installation.",
    },
  ];

  return (
    <Layout>
      <SEOHead
        title="Steel Fabrication Near Me | TR Structures – Hyderabad"
        description="TR Structures offers expert steel fabrication near you in Hyderabad, including sheet steel, structural steel, factory, warehouse, storage, poultry, farm, and portable sheds with precision and durability."
        keywords="steel fabrication, steel fabrication near me, sheet steel fabrication, structural steel fabrication, shed construction, industrial shed construction, poultry shed construction, steel fabrication Hyderabad, steel sheds Hyderabad"
      />
      <ServiceSchema
        serviceType="Shed Fabrication Services"
        description="Design, fabrication, welding, roofing and installation of factory, warehouse, storage, poultry, farm and portable sheds."
      />

      <main>
        <HeroSection
          title="Shed Fabrication Services"
          subtitle="Complete Shed Solutions"
          description="Premium shed fabrication services including design, planning, fabrication, welding, roofing, and final installation for all industrial needs."
          backgroundImage={heroImage}
          primaryButtonText="Get Quote"
          primaryButtonLink="/enquiry"
          secondaryButtonText="Contact Us"
          secondaryButtonLink="/contact"
        />

        {/* Main Content */}
        <section className="section-padding">
          <div className="container-custom">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="animate-slide-in-left order-2 lg:order-1">
                <h2 className="font-montserrat text-3xl md:text-4xl font-bold text-foreground mb-6">
                  Fabricated for <span className="text-secondary">Strength & Functionality</span>
                </h2>
                <p className="text-muted-foreground mb-4">
                  We fabricate sheds using MS steel, SS steel, galvanized sheets, PEB components, and high-quality roofing materials. Every shed is built to withstand industrial usage, outdoor weather, and long-term wear.
                </p>
                <p className="text-muted-foreground mb-6">
                  Our experienced fabricators ensure that each shed is perfectly aligned, structurally balanced, and optimized for maximum space usage.
                </p>

                <h3 className="font-montserrat text-xl font-bold text-foreground mb-4">
                  Types of Sheds We Fabricate:
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {shedTypes.map((type) => (
                    <div key={type} className="flex items-center gap-2 text-muted-foreground">
                      <svg
                        className="w-5 h-5 text-secondary flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      {type}
                    </div>
                  ))}
                </div>
              </div>

              <div className="animate-slide-in-right order-1 lg:order-2">
                <img
                  src={heroImage}
                  alt="Shed Fabrication"
                  className="rounded-xl shadow-2xl w-full object-cover h-full"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="section-padding bg-muted">
          <div className="container-custom">
            <div className="text-center mb-12">
              <h2 className="font-montserrat text-3xl md:text-4xl font-bold text-foreground mb-4">
                Why Choose Our <span className="text-primary">Shed Fabrication Services?</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feature, index) => (
                <div
                  key={feature.title}
                  className={`p-6 bg-card rounded-xl shadow-lg card-hover animate-slide-up stagger-${index + 1}`}
                  style={{ animationFillMode: "both" }}
                >
                  <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center mb-4">
                    <svg
                      className="w-6 h-6 text-secondary"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="font-montserrat text-xl font-bold text-foreground mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="section-padding bg-primary">
          <div className="container-custom text-center">
            <h2 className="font-montserrat text-3xl md:text-4xl font-bold text-primary-foreground mb-4">
              Your Shed, Built the Right Way
            </h2>
            <p className="text-primary-foreground/90 text-lg mb-8 max-w-2xl mx-auto">
              Whether you need a new shed, a custom design, or require restructuring of an old shed, TR Structures ensures precision, strength, and long-term reliability with every project.
            </p>
            <Link
              to="/enquiry"
              className="btn-secondary inline-block px-8 py-4 text-lg font-medium hover:bg-secondary/90 transition"
            >
              Get Your Custom Quote
            </Link>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default ShedFabrication;